import { render, staticRenderFns } from "./SetMoneyToTreatment.vue?vue&type=template&id=55258605&"
import script from "./SetMoneyToTreatment.vue?vue&type=script&lang=js&"
export * from "./SetMoneyToTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports